<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    export default {
        name: 'items',
        data () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// Items.vue?1f86a0d7